import {Link} from 'react-router-dom'

import './notFound.css'

const NotFound = () => {
  return (
    <section>
      <div className="container not-found__container">
      
      <h1>Whoopsie! 404</h1>
      <h2>You've gone beyond enlightenment and arrived back in oblivion! </h2>
      <Link to="/" className='btn'>Away Home!</Link>
      
      </div>

    </section>
  )
}

export default NotFound